import _extends from "@babel/runtime/helpers/esm/extends";
import { withStyles as withStylesWithoutDefault } from '@material-ui/styles';
import defaultTheme from './defaultTheme';

function withStyles(stylesOrCreator, options) {
  return withStylesWithoutDefault(stylesOrCreator, _extends({
    defaultTheme: defaultTheme
  }, options));
}

export default withStyles;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/styles/withStyles.js
// module id = 18
// module chunks = 121